const t=(t,e)=>{if(t&&e)return[t,e].join("/")};export{t as default};
